import React from 'react';
import { Toast as ToastType } from '../types';
import Toast from './Toast';
const TOAST_DURATION = 5000;

interface ToastContainerProps {
  toasts: ToastType[];
  removeToast: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  removeToast,
}) => {
  const cssForStyles = `
    @keyframes shrink {
      from {
        transform: scaleX(1);
      }
      to {
        transform: scaleX(0);
      }
    }
  `;

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-10 right-4 z-[9999] flex flex-col gap-3" data-cy="toast-container">
      <style>{cssForStyles}</style>
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          toast={toast}
          onRemove={removeToast}
          duration={TOAST_DURATION}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
